import { z } from 'zod'

import { OrganizationIdSchema } from '@mntn-dev/domain-types'
import type { ZodInfer } from '@mntn-dev/utility-types'

// Prototype for an eventual integration with the route params.
// This can be a superset of route params that individual routes can pick from.
// This really helps with the AnyRoute case where the params can be a subset of these instead of unknown.

export const RouteParamsSchema = z.object({
  organizationId: OrganizationIdSchema.optional(),
})

export type RouteParams = ZodInfer<typeof RouteParamsSchema>
